import React, { Component } from 'react';
import './sidebar.css';
import Sidebartop from '../sidebartop/sidebartop';
import Sidebarbottom from '../sidebarbottom/sidebarbottom';

class Sidebar extends Component {

    render() {

        return (
            <div className="sidebar">
                <Sidebartop {...this.props} />
                <Sidebarbottom {...this.props}/>
            </div>
        );
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js